/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';

import {
  dateIsValid,
  time2str,
  isoDate,
  parseISO
} from '../../../../utils/date-utils';

import { DatePicker } from '../../../../components/forms/date-picker';
import { CalendarException } from '../../../../types/calendar-exception';
import { Button, Checkbox } from 'semantic-ui-react';
import { QSContainer } from './layout-components';
import { t } from '../../../../locales/i18n';
import styled from 'styled-components';
import { sizes } from '../../../../themes/sizes';
import { colors } from '@nextinq/ui-toolkit';

const AddDatePanel = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  gap: ${sizes.margins.normal};
  align-self: start;
`;

const AddTimePanel = styled.section`
  display: grid;
  grid-template-columns: 75px 75px;
  gap: ${sizes.margins.normal};
  align-self: start;
`;
const TimeTogglePanel = styled.section`
  grid-row: 2;
  grid-column: 1/3;
  display: grid;
  grid-template-columns: auto auto;
  justify-content: space-between;
`;

const NotePanel = styled.section`
  grid-row: 3;
  grid-column: 1/3;
  display: grid;
  align-items: center;
  color: ${colors.grey.greyLighter};
  font-size: ${sizes.fonts.small};
`;

const ActionsPanel = styled.section`
  align-self: start;
  justify-items: center;
`;

interface RawAddCalendarExceptionProps {
  calendarException: CalendarException;
  onChange: (type: 'validFrom' | 'validTo' | 'from' | 'to', value: any) => void;
  disableAdd?: boolean;
  onAdd: () => void;
}

export function RawAddCalendarException(props: RawAddCalendarExceptionProps) {
  const { calendarException } = props;
  const [displayTime, setDisplayTime] = useState(false);
  const displayTimeKey = displayTime ? 'timeShown' : 'timeHidden';
  const displayTimeNote = t(`calExceptions.${displayTimeKey}.note`);
  return (
    <QSContainer>
      <AddDatePanel>
        <DatePicker
          type="date"
          value={calendarException.validFrom || ''}
          onChange={(value) => props.onChange('validFrom', isoDate(value))} //FIXME: tu by bolo lepsie ukladat to ako Date - datepicker by to potom vedel spravne formatovat
        />
        <DatePicker
          type="date"
          value={calendarException.validTo || ''}
          onChange={(value) => props.onChange('validTo', isoDate(value))}
        />
        <TimeTogglePanel>
          <label>{t(`calExceptions.displayTime.label`)}</label>
          <Checkbox
            toggle
            checked={displayTime}
            onChange={() => {
              setDisplayTime(!displayTime);
            }}
          />
        </TimeTogglePanel>
        <NotePanel>{displayTimeNote}</NotePanel>
      </AddDatePanel>

      <AddTimePanel>
        {displayTime && (
          <>
            <DatePicker
              type="time"
              value={calendarException.from}
              onChange={(value) => props.onChange('from', time2str(value))}
            />
            <DatePicker
              type="time"
              value={calendarException.to}
              onChange={(value) => props.onChange('to', time2str(value))}
            />
          </>
        )}
      </AddTimePanel>
      <ActionsPanel>
        <Button
          icon="add"
          basic
          primary
          circular
          disabled={props.disableAdd}
          onClick={() => props.onAdd()}
        />
      </ActionsPanel>
    </QSContainer>
  );
}

interface AddCalendarExceptionProps {
  onAdd: (calendarException: CalendarException) => void;
}
const initialState: CalendarException = {
  validTo: null,
  validFrom: null,
  from: '',
  to: ''
};

export class AddCalendarException extends React.Component<
  AddCalendarExceptionProps,
  CalendarException
> {
  override state = initialState;

  handleExceptionChange(key: string, val: any) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    this.setState({ [key]: val });
  }

  handleExceptionAdd() {
    const data = {
      ...this.state,
      validFrom: this.state.validFrom,
      validTo: this.state.validTo
    };

    this.props.onAdd(data);
    this.setState(initialState);
  }

  isValid() {
    return dateIsValid(this.state.validFrom) && dateIsValid(this.state.validTo);
  }

  override render() {
    return (
      <RawAddCalendarException
        calendarException={this.state}
        disableAdd={!this.isValid()}
        onChange={(key, val) => this.handleExceptionChange(key, val)}
        onAdd={() => this.handleExceptionAdd()}
      />
    );
  }
}
